export enum DeviceEnum {
  Mobile = 1,
  Laptop,
  MobileLaptop,
  LaptopMobile
}
